import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

import { useAuth0 } from '@auth0/auth0-react';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props, RedirectLoginOptions } from './types';

const SignupPage: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
    const { tag } = useParams();

    const unauthenticatedOptions = useRef<RedirectLoginOptions>({
        authorizationParams: {
            registration_tag: tag,
            screen_hint: 'signup'
        }
    });

    useEffect(() => {
        if (!isLoading && !isAuthenticated) {
            loginWithRedirect(unauthenticatedOptions.current);
        }
    }, [isAuthenticated, isLoading, loginWithRedirect]);

    return <div data-testid={testId} />;
};

export default SignupPage;
